import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Smooth scroll via Lenis — gated by prefers-reduced-motion.
 * When reduce is set, native scroll is used (no rAF hijack).
 */
export default function SmoothScroll({ children }) {
  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (media.matches) return undefined;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
    });
    let raf;
    function tick(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    const onChange = (event) => {
      if (event.matches) {
        cancelAnimationFrame(raf);
        lenis.destroy();
      }
    };
    media.addEventListener("change", onChange);

    return () => {
      media.removeEventListener("change", onChange);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
}
